<template>
  <div id="managementPointEdit">
    <b>管理人月数情報一覧</b><br/><br/>

    <table>
      <tr>
        <td>コメントと管理人月数情報を管理いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader" class="table table-striped">
          <tbody>
            <tr>
              <td><b>リーダー：</b></td>
              <td>{{$route.params.memberName}}</td>
            </tr>
            <tr>
              <td><b>年月：</b></td>
              <td>{{$route.params.yearMonth.substring(0,4)}}/{{$route.params.yearMonth.substring(4)}}</td>
            </tr>
            <tr>
              <td><b>プロジェクト情報：</b></td>
              <td> <div v-for="(rowCellItem, index3) in projects" v-bind:key="'rowCellItem' + index3">
                      {{ rowCellItem.projectInfo.projectName }}
                     <br/>
                    <span v-if="rowCellItem.allLeaderMemberName">         
                    &nbsp;&nbsp;&nbsp;リーダー:{{ rowCellItem.allLeaderMemberName }}<br/>
                    </span> 
                    <span v-if="rowCellItem.allGeneralMemberName">   
                    &nbsp;&nbsp;&nbsp;メンバー:{{ rowCellItem.allGeneralMemberName }}<br/>
                    </span> 
                    <span v-if="rowCellItem.allHelperMemberName">   
                    &nbsp;&nbsp;&nbsp;ヘルパー:{{ rowCellItem.allHelperMemberName }}<br/>
                    </span>
                  </div></td>
            </tr>
            <tr v-if="rows">
              <td><b>コメント：</b></td>
              <td><textarea style="width: 100%;height: 200px"   maxlength="4000" v-model="rows[0].managementComment"/></td>
            </tr>
            <tr v-if="rows">
              <td><b>管理人月数：</b></td>
              <td><input  type="number"  style="width: 20%;" step="0.01" v-model="rows[0].managementPoint">人月</td>
            </tr>
          </tbody>
        </table>
        
      </div><br/>
      <button id="saveBtn" v-on:click="processClick" class="btn-mid" style="width:250px;" >変更</button>&nbsp;
      <button @click="$router.back(-1);" class="btn-mid" style="width:250px;">キャンセル</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "managementPointEdit",
    props: ['projects'],
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          // heads: [ ],
          rows:  null ,
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/managementPointEditInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                // self.heads = res.data.heads;
                self.rows = res.data.rows;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });
      },
      processClick: function () {
        var self = this;
        self.rows[0].memberID = self.$route.params.memberID;
        self.rows[0].yearMonth = self.$route.params.yearMonth;
        var data = { rowData:JSON.stringify(self.rows[0]) };
        $("#saveBtn").attr("disabled", true);
        common.getAxios().post(process.env.API_URL +"/api/managementPointEditProcess", data)
          .then(function (res) {
            $("#saveBtn").attr("disabled", false);
            // 処理正常の場合
            if (res.data == '') {
              self.$router.push({ name: 'sales', params: { } });
            }
            // 処理エラーの場合
            else {
              alert(res.data);
            }
          })
          .catch(function (err) {
            $("#saveBtn").attr("disabled", false);
            alert(err);
          });
      },

    }
  };
</script>



// WEBPACK FOOTER //
// managementPointEdit.vue?0844888e